// Sticky bottom bar shown during proofing once the client has favorited at least one
// photo. Surfaces live count, included edits, and extras pricing so the client knows
// exactly what they're committing to before tapping Send.
export default function SelectionBar({
  favCount,
  includedEdits,
  extraCount,
  extraTotal,
  maxSel,
  onOpenSubmit,
}) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-stone-900 text-stone-50 px-4 py-3 z-30" data-testid="selection-bar">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="text-sm">
          <strong>{favCount}</strong> photo{favCount > 1 ? "s" : ""} favorited
          {includedEdits > 0 && (
            <>
              {" "}· {Math.min(favCount, includedEdits)} included
              {extraCount > 0 && (
                <>
                  {" "}·{" "}
                  <span className="text-amber-300">
                    {extraCount} extra (+${extraTotal.toFixed(2)})
                  </span>
                </>
              )}
            </>
          )}
          {maxSel > 0 && <> · max {maxSel}</>}
        </div>
        <button
          onClick={onOpenSubmit}
          disabled={maxSel > 0 && favCount > maxSel}
          className="px-5 h-10 bg-stone-50 text-stone-900 text-xs uppercase tracking-[0.22em] hover:bg-white disabled:opacity-50"
          data-testid="open-submit-btn"
        >
          Send selections
        </button>
      </div>
    </div>
  );
}
